import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/api';
import { UseQueryConfig } from '@/api/types';
import { ResourceReleaseNotesQueryParams } from '@/api/apis/resources/release-notes';
import { resourceReleaseNotesQueryKeys } from './release-notes.keys';

export const resourceReleaseNotesQueries = {
  list: (product: string, params?: ResourceReleaseNotesQueryParams) =>
    queryOptions({
      queryKey: resourceReleaseNotesQueryKeys.list(product, params),
      queryFn: () => api.resourceReleaseNotes.getReleaseNotes(product, params ?? {}),
    }),
};

export const useResourceReleaseNotesQuery = (
  product: string,
  params?: ResourceReleaseNotesQueryParams,
  options?: UseQueryConfig,
) => {
  return useQuery({ ...resourceReleaseNotesQueries.list(product, params), ...options });
};
